import { useAccountMembersQuery } from '~/generated/graphql';

export function useAccountMembers() {
  const { loading, data, refetch } = useAccountMembersQuery();

  return {
    loading,
    members: data?.account?.members?.nodes ?? [],
    invites: data?.account?.membershipInvites?.nodes ?? [],
    refetchMembers: refetch,
  };
}
